import { Users } from 'lucide-react';
import { TravelerCard } from '../cards/TravelerCard';
import { SectionHeader, EmptyState } from '../shared/InfoGrid';
import type { Traveler } from '../utils/types';

interface TravelersTabProps {
  travelers: Traveler[];
}

export function TravelersTab({ travelers }: TravelersTabProps) {
  if (!travelers || travelers.length === 0) {
    return (
      <EmptyState
        icon={<Users className="h-6 w-6" />}
        title="No travelers"
        description="This booking doesn't contain any traveler information"
      />
    );
  }

  return (
    <div>
      <SectionHeader
        title="Travelers"
        icon={<Users className="h-5 w-5" />}
        count={travelers.length}
      />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
        {travelers.map(traveler => (
          <TravelerCard key={traveler.id} traveler={traveler} />
        ))}
      </div>
    </div>
  );
}
